






import { defineComponent, computed } from '@vue/composition-api'
import cssVariables from './styles/css-variables'

export default defineComponent({
  name: 'App',
  setup() {
    const appStyle = computed(() => {
      return cssVariables
    })
    return { appStyle }
  },
})
